/* eslint no-console: ["error", { allow: ["error", "log"] }] */
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { useMsal, useAccount } from '@azure/msal-react';
import { protectedResources } from '../../authConfig';
import axios from 'axios';
import { useCallback } from 'react';

const useAxios = () => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const getToken = useCallback(async() => {
        if (!account) {
            return null;
        }

        const silentRequest = {
            account,
            ...protectedResources.api,
            forceRefresh: false,
        };

        try {
            console.log('Attempting to acquire token silently...');
            const response = await instance.acquireTokenSilent(silentRequest);
            console.log('Token acquired silently:', response);
            return response.accessToken;
        } catch (error) {
            console.error('Silent token acquisition failed:', error);
            if (error instanceof InteractionRequiredAuthError) {
                const interactiveRequest = {
                    ...protectedResources.api,
                };
                console.log('Attempting to acquire token via redirect...');
                await instance.acquireTokenRedirect(interactiveRequest);
                return null;
            } else {
                throw error;
            }
        }
    }, [account, instance]);

    const callApi = useCallback(async(config) => {
        const accessToken = await getToken();

        return await axios({
            ...config,
            headers: {
                ...config.headers,
                Authorization: `Bearer ${accessToken}`,
            },
        })
    }, [getToken]);

    return { callApi };
};

export default useAxios;